import React, { Component, Fragment } from "react";

import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import DatePicker from "Components/New/Input/DatePicker/DatePicker";
import Select from "Components/New/Input/Select/Select";
import TextField from "Components/New/Input/TextField/TextField";

import IconButton from "@material-ui/core/IconButton/IconButton";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import AddIcon from "@material-ui/icons/AddCircle";
import TrashIcon from "@material-ui/icons/Delete";
import localize from "helpers/localize";

export const KEYGEN_ANNREV = "ANNREV";
export const KEYGEN_BATTERY = "BATTERY";
export const KEYGEN_RS232 = "RS232";
export const KEYGEN_REREG = "REREG";
const emptyRow = () => {
  return {
    keygen: null,
    distributor_id: null,
    value: "",
    valid_until: null,
    ap_filter: ""
  };
};

class StickerCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [emptyRow()],
      errors: null
    };
  }

  resetRows = () => {
    this.setState({ rows: [emptyRow()] });
  };

  addRow = () => {
    let rows = this.state.rows.slice();
    rows.push(emptyRow());
    //console.log(rows);
    this.setState({ rows });
  };

  removeRow = index => {
    let rows = this.state.rows.slice();
    rows.splice(index, 1);
    this.setState({ rows });
  };

  setRowValue = (index, name, value) => {
    let rows = this.state.rows.slice();
    rows[index][name] = value;
    this.setState({ rows });
  };

  validateRange = (start, end) => {
    //lol
  };

  getCount = row => {
    const params = this.getValueParams(row);

    if (!params) {
      return 0;
    }

    return params.count;
  };
  getValueParams = row => {
    if (!row || !row.value) {
      return null;
    }
    let start = null;
    let end = null;
    let error = null;
    let count = 0;

    if (row.value.indexOf("-") >= 0) {
      const [_start, _end] = row.value.split("-");
      start = parseInt(_start.trim());
      end = parseInt(_end.trim());
      count = end - start + 1;
      if (end === 0) {
        error = true;
      }
    } else if (row.value.indexOf(",") >= 0) {
      const [_start, _count] = row.value.split(",");
      start = parseInt(_start.trim());
      count = parseInt(_count.trim());
      end = start + count - 1;
      if (count === 0) {
        error = true;
      }
    } else {
      return null;
    }
    if (isNaN(count)) {
      count = 0;
      error = true;
    }
    return { start, end, count, error };
  };

  transformRow = row => {
    const params = this.getValueParams(row);

    if (!params) {
      return [row];
    }
    let stickers = [];
    for (let value = params.start; value <= params.end; value++) {
      stickers.push(Object.assign({}, row, { value }));
    }

    return stickers;
  };

  transformRows = () => {
    const { rows } = this.state;

    let stickers = [];
    rows.forEach(row => {
      stickers = stickers.concat(this.transformRow(row));
    });
    return stickers;
  };

  validateRow = row => {
    //console.log(row);
    const params = this.getValueParams(row);
    let error = {};
    let hasError = false;

    if (!row.distributor_id) {
      error.keygen = localize("stickers", "Nincs Kulcsgenerálás");
      hasError = true;
    }

    if (!row.distributor_id) {
      error.distributor_id = localize("stickers", "Nincs viszonteladó");
      hasError = true;
    }

    if (!row.valid_until) {
      error.valid_until = localize("stickers", "Nincs érvényesség dátuma");
      hasError = true;
    }

    if (!row.value) {
      error.value = localize("stickers", "Nincs matricaszám");
      hasError = true;
    } else if (params) {
      if (params.error) {
        error.value = localize("stickers", "Hibás tartomány");
        hasError = true;
      } else if (params.count <= 0) {
        error.value = localize("stickers", "Negatív tartomány");
        hasError = true;
      }
    }

    /*if (!row.ap_filter) {
      error.ap_filter = "Nincs AP szűrő";
      hasError = true;
    }*/

    if (hasError) {
      return error;
    }
  };

  getErrors = () => {
    const { rows } = this.state;

    let errors = {};
    let hasError = false;
    rows.forEach((row, index) => {
      //console.log(index);
      const error = this.validateRow(row);
      if (error) {
        errors[index] = error;
        hasError = true;
      }
    });

    if (hasError) {
      this.setState({ errors });
    } else {
      this.setState({ errors: null });
    }

    return hasError ? errors : null;
  };

  needConfirm = () => {
    const { rows } = this.state;

    let hasError = false;
    rows.forEach(row => {
      const params = this.getValueParams(row);
      if (params && params.count > 50) {
        hasError = true;
      }
    });

    return hasError;
  };

  render() {
    const { rows, errors } = this.state;
    const getError = (index, key) =>
      errors && errors[index] && errors[index][key]
        ? errors[index][key]
        : undefined;

    let currentIndex = 0;
    return (
      <Fragment>
        <Typography
          variant="caption"
          color="textSecondary"
          style={{ marginBottom: 16 }}
        >
          * - {localize("stickers", "A mező elfogad matrica tartományt is.")}{" "}
          1.: [{localize("stickers", "kezdő matrica")}]-[
          {localize("stickers", "befejezőmatrica")}]{" "}
          {localize("stickers", "pl.")}:{" "}
          <b style={{ marginRight: 16 }}>170510-170550</b> 2.: [
          {localize("stickers", "kezdő matrica")}],[
          {localize("stickers", "darabszám")}] {localize("stickers", "pl.")}:
          <b>170510,40</b>
        </Typography>
        <Table padding="none">
          <TableHead>
            <TableRow style={{ height: "unset" }}>
              <TableCell />
              <TableCell style={{ paddingLeft: 4 }}>
                {localize("stickers", "Kulcsgenerálás")}
              </TableCell>
              <TableCell style={{ paddingLeft: 4 }}>
                {localize("stickers", "Viszonteladó")}
              </TableCell>
              <TableCell style={{ paddingLeft: 4 }}>
                {localize("stickers", "Matrica szám/tartomány")}*
              </TableCell>
              <TableCell style={{ paddingLeft: 4 }}>
                {localize("stickers", "Érvényes")}
              </TableCell>
              <TableCell style={{ paddingLeft: 4 }}>
                {localize("stickers", "AP szűrő")}
              </TableCell>
              <TableCell style={{ paddingLeft: 4 }}>
                <Tooltip title={localize("stickers", "Új hozzáadása")}>
                  <IconButton
                    style={{ width: 24, height: 24, padding: 0 }}
                    onClick={this.addRow}
                    color="primary"
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => {
              const count = this.getCount(row);
              currentIndex += count > 0 ? count : 1;
              return (
                <TableRow key={index}>
                  <TableCell
                    style={{ width: 70, textAlign: "left", fontSize: 15 }}
                  >
                    <Badge
                      //style={{ fontSize: 10 }}
                      color={
                        count > 50
                          ? "secondary"
                          : count <= 0
                          ? "error"
                          : "primary"
                      }
                      badgeContent={count}
                    >
                      {count > 0
                        ? `${currentIndex - count + 1}-${currentIndex}`
                        : currentIndex}
                      .
                    </Badge>
                  </TableCell>
                  <TableCell
                    style={{ width: 160, paddingRight: 5, overflow: "visible" }}
                  >
                    <Select
                      type="dropdown"
                      id="fos"
                      value={row.keygen}
                      options={{
                        [KEYGEN_ANNREV]: KEYGEN_ANNREV,
                        [KEYGEN_BATTERY]: KEYGEN_BATTERY,
                        [KEYGEN_REREG]: KEYGEN_REREG,
                        [KEYGEN_RS232]: KEYGEN_RS232
                      }}
                      fullWidth
                      onChange={(obj, id) => {
                        this.setRowValue(index, "keygen", id);
                      }}
                      error={getError(index, "keygen")}
                    />
                  </TableCell>
                  <TableCell style={{ width: 350, overflow: "visible" }}>
                    <Select
                      type="autocomplete"
                      value={row.distributor_id}
                      url="distributors/autocomplete?attribute=company_name"
                      fullWidth
                      onChange={(obj, id) =>
                        this.setRowValue(index, "distributor_id", id)
                      }
                      error={getError(index, "distributor_id")}
                    />
                  </TableCell>
                  <TableCell style={{ paddingLeft: 4 }}>
                    <TextField
                      value={row.value}
                      fullWidth
                      error={getError(index, "value")}
                      onChanged2={evt =>
                        this.setRowValue(index, "value", evt.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell style={{ paddingLeft: 4 }}>
                    <DatePicker
                      value={row.valid_until}
                      valueFormat="Y.MM.DD"
                      fullWidth
                      inline
                      error={getError(index, "valid_until")}
                      onChange={date =>
                        this.setRowValue(index, "valid_until", date)
                      }
                    />
                  </TableCell>
                  <TableCell style={{ paddingLeft: 4, width: 200 }}>
                    {/*<Tags
                    value={row.ap_filter}
                    fullWidth
                    valueKey="value"
                    labelKey="label"
                    onChange={tags =>
                      this.setRowValue(index, "ap_filter", tags)
                    }
                  />*/}
                    <Select
                      type="autocomplete"
                      value={row.ap_filter}
                      url="stickers/autocomplete?attribute=company_name"
                      fullWidth
                      onChange={(obj, id) =>
                        this.setRowValue(index, "ap_filter", id)
                      }
                    />
                  </TableCell>
                  <TableCell style={{ paddingLeft: 4 }}>
                    {rows.length > 1 && (
                      <Tooltip title="Sor törlése">
                        <IconButton
                          style={{ width: 24, height: 24, padding: 0 }}
                          onClick={() => this.removeRow(index)}
                          color="secondary"
                        >
                          <TrashIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Fragment>
    );
  }
}

StickerCreate.propTypes = {};

export default StickerCreate;
